











import Vue from 'vue'
import {
  DeliveryTimeCandidate,
  AvailableDeliveryCount,
} from '@/types/generated/graphql'
import { range } from 'lodash'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'

type Props = {
  value?: number
  candidates: DeliveryTimeCandidate[]
  deliveryFrequency: string
  availableDeliveryCount: Array<AvailableDeliveryCount>
}

type Computed = {
  localValue?: number
  maxDeliveryCount: number
  options: OptionEntry<number | undefined>[]
}

export default Vue.extend<{}, {}, Computed, Props>({
  inheritAttrs: false,
  name: 'NumberOfDeliveriesPicker',
  components: { XDropdown },
  props: {
    value: {
      type: Number,
    },
    candidates: {
      type: Array,
    },
    deliveryFrequency: {
      type: String,
      required: false,
    },
    availableDeliveryCount: {
      type: Array,
      required: true,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    maxDeliveryCount() {
      const defaultMaxCount = 4
      if (
        this.deliveryFrequency === undefined ||
        this.availableDeliveryCount === undefined
      ) {
        return 0
      }
      const availableCount = this.availableDeliveryCount.find(
        (e: AvailableDeliveryCount) =>
          e.deliveryFrequency === this.deliveryFrequency
      )

      if (availableCount === undefined) {
        return 0
      }

      return availableCount.count > defaultMaxCount
        ? defaultMaxCount
        : availableCount.count
    },
    options() {
      const max = this.maxDeliveryCount
      const emptyOpt = { value: undefined, label: '' }

      if (max === 0) {
        return [emptyOpt]
      }
      const values = range(1, max + 1)
      const options = values.map((value) => ({ value, label: String(value) }))

      return [emptyOpt, ...options]
    },
  },
})
